/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { ApplicationState } from 'store';
import { ConcurrentsState } from 'store/modules/concurrents_store/types';
import {
  getCompanyData,
  listMyBiddings,
  ListStrategicAspects,
  Sanctions,
} from 'store/modules/concurrents_store/actions';
import AdministrativeAnalysis from 'components/molecules/administrative_analysis';
import ParticipationAnalysis from 'components/molecules/participation_analysis';
import SanctionsAnalysis from 'components/molecules/sanctions_analysis';
import loading from 'assets/animations/loading_new.gif';
import Onboarding from 'components/molecules/onboarding';
import { hasCookie } from 'services/actions/cookies_actions';
import StrategicAspects from 'components/molecules/strategicAspects';
import { Container } from './styles';

const ConcurrentsData = () => {
  const { cnpj } = useParams<{ cnpj: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const [currentPageSanctions, setCurrentPageSanctions] = useState<number>(1);

  const { concurrents, request } = useSelector<ApplicationState, ConcurrentsState>(
    (state) => state.session.concurrents,
  );

  const paginate = (currentPageResult = 1) => {
    if (currentPageResult) {
      setCurrentPageSanctions(currentPageResult);
      if (concurrents?.sanctions_list?.length > 0) {
        const params = {
          cnpj,
        };
        dispatch(Sanctions(params, currentPageSanctions));
      }
    }
  };

  useEffect(() => {
    document.title = 'Concorrentes - ConLicitação';

    if (cnpj) {
      dispatch(getCompanyData(cnpj));
      const params = {
        cnpj,
      };
      dispatch(Sanctions(params, currentPageSanctions));
      dispatch(listMyBiddings(cnpj));
      dispatch(ListStrategicAspects(cnpj));
    }
  }, [cnpj, dispatch]);

  const company = concurrents?.company?.[0]?.empresa;

  const categoryColors = {
    administrativa: '#6c757d',
    participacoes: '#009F79',
    sancoes: '#dc3545',
    strategicAspects: '#007BFF',
  };

  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'Análise administrativa':
        return categoryColors.administrativa;
      case 'Participações':
        return categoryColors.participacoes;
      case 'Sanções / Penalizações':
        return categoryColors.sancoes;
      case 'Aspectos estratégicos':
        return categoryColors.strategicAspects;
      default:
        return '#6c757d';
    }
  };

  const getCategoryTourClass = (category: string) => {
    switch (category) {
      case 'Análise administrativa':
        return 'tour-concurrents-admin';
      case 'Participações':
        return 'tour-concurrents-participation';
      case 'Sanções / Penalizações':
        return 'tour-concurrents-sanction';
      default:
        return 'tour-concurrents';
    }
  };

  return (
    <Container>
      <div className="page-container">
        <div className="container-fluid big-resolutions p-3">
          <h6>Análise de concorrentes:</h6>
          <div className="d-flex flex-wrap align-items-center">
            <h3 className="mb-2 mb-md-0 mr-3">
              {company
                ? `${company.razao_social} - ${company.cnpj.replace(
                    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/,
                    '$1.$2.$3/$4-$5',
                  )}`
                : '-'}
            </h3>
            <button
              type="button"
              className="btn btn-primary btn-sm ms-md-3"
              onClick={() => history.push('/concorrentes')}
            >
              Buscar novo CNPJ
            </button>
          </div>
          {request?.company?.loading ? (
            <div className="text-center">
              <img className="mr-2" src={loading} alt="loading" width="25%" />
            </div>
          ) : (
            <>
              <div className="tour-concurrents-dashboard card p-3 mt-4">
                <h5 className="d-flex align-items-center mb-4 font-weight-bold">
                  <i className="material-icons mr-2 text-warning">error</i>
                  Alertas de Vulnerabilidades:
                </h5>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="card card-titulo h-100">
                      <div className="card-body">
                        <p className="card-text text-dark">Desclassificações:</p>
                        <h4 className="card-title font-weight-bold">
                          {concurrents?.strategic_aspects?.desclassificacoes}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="card card-titulo h-100">
                      <div className="card-body">
                        <p className="card-text text-dark">Inabilitações:</p>
                        <h4 className="card-title font-weight-bold">
                          {concurrents?.strategic_aspects?.inabilitacoes}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="card card-titulo h-100">
                      <div className="card-body">
                        <p className="card-text text-dark">Sanções:</p>
                        <h4 className="card-title font-weight-bold">
                          {concurrents?.sanctions_list?.length}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" mt-4">
                <div id="accordion" className="mt-3">
                  {[
                    {
                      id: 'admin',
                      icon: 'description',
                      title: 'Análise administrativa',
                      component: <AdministrativeAnalysis company={concurrents?.company?.[0]} />,
                    },
                    {
                      id: 'participacoes',
                      icon: 'bar_chart',
                      title: 'Participações',
                      component: <ParticipationAnalysis cnpj={cnpj} />,
                    },
                    {
                      id: 'sancoes',
                      icon: 'report_problem',
                      title: 'Sanções / Penalizações',
                      component: (
                        <SanctionsAnalysis
                          paginate={paginate}
                          currentPageSanctions={currentPageSanctions}
                        />
                      ),
                    },
                    {
                      id: 'strategicAspects',
                      icon: 'query_stats',
                      title: 'Aspectos estratégicos',
                      component: <StrategicAspects />,
                    },
                  ].map((item) => (
                    <div className={`${getCategoryTourClass(item.title)} card my-3`} key={item.id}>
                      <div className="card-header" id={`heading-${item.id}`}>
                        <h5 className="mb-0">
                          <button
                            type="button"
                            className="btn d-flex justify-content-between align-items-center w-100 text-left p-0"
                            data-toggle="collapse"
                            data-target={`#collapse-${item.id}`}
                            aria-expanded="false"
                            aria-controls={`collapse-${item.id}`}
                          >
                            <span className="d-flex align-items-center">
                              <i
                                className="material-icons mr-2"
                                style={{ color: getCategoryColor(item.title) }}
                              >
                                {item.icon}
                              </i>
                              {item.title}
                            </span>
                            <i className="material-icons transition-icon ml-2">expand_more</i>
                          </button>
                        </h5>
                      </div>

                      <div
                        id={`collapse-${item.id}`}
                        className="collapse"
                        aria-labelledby={`heading-${item.id}`}
                        data-parent="#accordion"
                      >
                        <div className="card-body">{item.component}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {!hasCookie('tourConcurrentsPage') && <Onboarding tourSelect="tourConcurrentsPage" />}
            </>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ConcurrentsData;
